var map = {
	"./1/symbol_0.png": 11300,
	"./1/symbol_1.png": 65197,
	"./1/symbol_10.png": 97881,
	"./1/symbol_11.png": 976,
	"./1/symbol_12.png": 70827,
	"./1/symbol_2.png": 34870,
	"./1/symbol_3.png": 48159,
	"./1/symbol_4.png": 96832,
	"./1/symbol_5.png": 74953,
	"./1/symbol_6.png": 60338,
	"./1/symbol_7.png": 75163,
	"./1/symbol_8.png": 78924,
	"./1/symbol_9.png": 31189,
	"./2/symbol_0.png": 41361,
	"./2/symbol_1.png": 43496,
	"./2/symbol_10.png": 53626,
	"./2/symbol_11.png": 75203,
	"./2/symbol_12.png": 38344,
	"./2/symbol_2.png": 28771,
	"./2/symbol_3.png": 11194,
	"./2/symbol_4.png": 67701,
	"./2/symbol_5.png": 98604,
	"./2/symbol_6.png": 18663,
	"./2/symbol_7.png": 350,
	"./2/symbol_8.png": 29257,
	"./2/symbol_9.png": 74432,
	"./3/symbol_0.png": 67598,
	"./3/symbol_1.png": 67095,
	"./3/symbol_10.png": 85911,
	"./3/symbol_12.png": 14693,
	"./3/symbol_2.png": 59516,
	"./3/symbol_3.png": 95429,
	"./3/symbol_4.png": 25002,
	"./3/symbol_5.png": 56915,
	"./3/symbol_6.png": 61304,
	"./3/symbol_7.png": 82433,
	"./3/symbol_8.png": 54566,
	"./3/symbol_9.png": 36111,
	"./4/symbol_0.png": 22555,
	"./4/symbol_1.png": 7730,
	"./4/symbol_10.png": 65192,
	"./4/symbol_12.png": 37338,
	"./4/symbol_2.png": 38697,
	"./4/symbol_3.png": 44224,
	"./4/symbol_4.png": 95551,
	"./4/symbol_5.png": 98614,
	"./4/symbol_6.png": 12589,
	"./4/symbol_7.png": 58692,
	"./4/symbol_8.png": 2563,
	"./4/symbol_9.png": 54810,
	"./gamble/btn_HIGH_lose.png": 58857,
	"./gamble/btn_HIGH_normal.png": 78695,
	"./gamble/btn_HIGH_win.png": 42410,
	"./gamble/btn_LOW_lose.png": 21015,
	"./gamble/btn_LOW_normal.png": 73497,
	"./gamble/btn_LOW_win.png": 84372,
	"./gamble/btn_collect.png": 39283,
	"./gamble/history_lose.png": 92874,
	"./gamble/history_win.png": 16071,
	"./gamble/wheel_HIGH_lose.png": 94416,
	"./gamble/wheel_HIGH_win.png": 6801,
	"./gamble/wheel_LOW_lose.png": 37207,
	"./gamble/wheel_LOW_win.png": 61637,
	"./gold1.png": 45514,
	"./gold2.png": 94497,
	"./gold3.png": 21784,
	"./gold4.png": 1399,
	"./header_slotmachine_freespin._no_fg.png": 29989,
	"./silver1.png": 80021,
	"./silver2.png": 43294,
	"./silver3.png": 19079,
	"./silver4.png": 39464,
	"./slotmachine.png": 51046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13270;